import axiosInstance from "../../../interceptors/token";
import { API_BASE_URL } from "../../../constants";

export const calculateTotalWorkHours = async (projectID, selectedDate, formData, startDate, endDate) => {
    let totalWorkHours = 0;

    totalWorkHours += parseFloat(formData?.preparation);
    totalWorkHours += parseFloat(formData?.transport);
    totalWorkHours += parseFloat(formData?.warehouse);
    totalWorkHours -= parseFloat(formData?.break);

    totalWorkHours += (endDate - startDate) / 60000 / 60;;

    try {
        const totalHoursResponse = await axiosInstance.get(
            `${API_BASE_URL}werk/total_hours/`,
            { params: { date: selectedDate, exclude: projectID } }
        );
    
        if (totalHoursResponse.data && typeof totalHoursResponse.data.total_hours === "number") {
            totalWorkHours += totalHoursResponse.data.total_hours;
        } else {
            console.warn("Unexpected response format:", totalHoursResponse.data);
        }
    } catch (error) {
        console.error("Failed to fetch total work hours:", error);
    }
    return totalWorkHours
}